import React, { ReactNode } from 'react';
import { Modal } from '../../../../ui/Modal';
import {
  ModalContent,
  modalHeaderStyles,
  modalStyles,
  ReportBackButton
} from './styled';
import { BackButtonIconEnum } from '../../../../ui/PageHeader/types';

interface ReportModalProps {
  children: ReactNode;
  isOpen: boolean;
  closeHandler: () => void;
  handleBack: () => void;
  title?: string;
  isInputModal?: boolean;
}

export const ReportModal: React.FC<ReportModalProps> = ({
  children,
  title,
  isOpen,
  isInputModal = false,
  handleBack,
  closeHandler
}) => {
  const isLongTitle = (title?.length || 0) > 35;

  return (
    <Modal
      modalId="report"
      cypress="report-modal"
      onClose={closeHandler}
      lockScrollContent={false}
      isOpen={isOpen}
      title={title}
      closeButtonAlign="right"
      modalStyles={modalStyles}
      showHeaderBorder={false}
      headerStyles={modalHeaderStyles(!!isInputModal, isLongTitle)}
      headerIcon={BackButtonIconEnum.Close}
      headerLeftBlock={
        isInputModal ? (
          <ReportBackButton type="button" onClick={handleBack} />
        ) : null
      }
    >
      <ModalContent data-cy="report-container">{children}</ModalContent>
    </Modal>
  );
};
